import { Div2Floor } from "../utils/Div2Floor";
import { enumElementDrawStates, kCheckBoxSize } from "../constants";
import { QToggleBox } from "./QToggleBox";
import { shadeColor } from "../utils/shadeColor";
import { Globals } from "./Globals.js";

export class QRadioButton extends QToggleBox {
  constructor() {
    super();
  }

  InitRadioButton(parentGroup) {
    this.InitToggleBox(parentGroup);
  }

  RenderButton(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.lineWidth = 1;

    var drawState = this.GetDrawState();
    var isPressed = drawState === enumElementDrawStates.MouseDown;
    var isHover = drawState === enumElementDrawStates.Hover;

    var shade = 0;
    if (isPressed) shade = -10;
    else if (isHover) shade = 10;

    var selectedFillColor = shadeColor(this.fUIColors.GetPagingBlueColor(), shade);
    var unSelectedFillColor = this.fUIColors.GetTextEditFillColor();
    var unSelectedStrokeColor = Globals._themeMode.text.header;

    if (isPressed || isHover) unSelectedStrokeColor = selectedFillColor;

    var isChecked = this.IsChecked();

    ctx.fillStyle = isChecked ? selectedFillColor : unSelectedFillColor;
    ctx.strokeStyle = isChecked ? selectedFillColor : unSelectedStrokeColor;

    if (drawState === enumElementDrawStates.Disabled) {
      ctx.fillStyle = this.fUIColors.GetDisabledTextColor();
      ctx.strokeStyle = this.fUIColors.GetDisabledTextColor();
      ctx.globalAlpha = 0.7;
    }

    var cx = this.fHorzOffset + kCheckBoxSize / 2;
    var cy;
    if (this.fLabel1 == null)
      cy =
        this.fVertOffset +
        Math.floor(this.fHeight / 2) -
        Math.floor(kCheckBoxSize / 2) +
        kCheckBoxSize / 2;
    else cy = this.fVertOffset + 2;

    var rOuter = kCheckBoxSize / 2 + 0.5;
    var rInner = Div2Floor(rOuter) + 0.5;

    if (!this.fUIColors.InDarkMode()) rInner += 0.5;

    ctx.beginPath();
    ctx.arc(cx, cy, rOuter, 0, 2 * Math.PI);
    ctx.stroke();

    // Inner (Selected state)
    if (isChecked) {
      ctx.beginPath();
      ctx.arc(cx, cy, rInner, 0, 2 * Math.PI);
      ctx.fill();
    }
  }
}
